import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import UserTruckImplement from './user-truck-implement';
import UserTruckImplementDetail from './user-truck-implement-detail';
import UserTruckImplementUpdate from './user-truck-implement-update';
import UserTruckImplementDeleteDialog from './user-truck-implement-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={UserTruckImplementUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={UserTruckImplementUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={UserTruckImplementDetail} />
      <ErrorBoundaryRoute path={match.url} component={UserTruckImplement} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={UserTruckImplementDeleteDialog} />
  </>
);

export default Routes;
